// extracted by mini-css-extract-plugin
export default {"rateField":"PostMultiday_rateField__ynYki"};